import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Paper, Typography, Button, Divider, Avatar, Grid, CircularProgress, Box, TextField, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { ArrowBack, PersonOutline } from '@mui/icons-material';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';

function ShowAcceptedUsers({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const location = useLocation(); // Access location object
  const { bookedUsers } = location.state || {}; // Retrieve the bookedUsers from state
  const navigate = useNavigate(); 

  const [loading, setLoading] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState('');
  const [meetingLink, setMeetingLink] = useState('');

  if (!bookedUsers || bookedUsers.length === 0) {
    return (
      <Paper sx={{ padding: '2rem', textAlign: 'center', backgroundColor: '#000000', height: '100vh' }}>
        <Typography variant="h5" color="error" sx={{ marginBottom: '1rem', color: '#FF6347' }}>
          No booked users found.
        </Typography>
        <Button variant="contained" color="primary" href="/dashboard" sx={{ borderRadius: '30px' }}>
          Back to Dashboard
        </Button>
      </Paper>
    );
  }

  const handleClick = () => {
    navigate(`/platform/${userId}`)
  }

  const handleAccept = (user) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      alert(`User ${user} accepted!`);
    }, 1000);
  }

  const handleReject = (user) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      alert(`User ${user} rejected!`);
    }, 1000);
  }

  return (
    <Paper sx={{ padding: '2rem', backgroundColor: '#000000', minHeight: '100vh' }}>
      <Header1 userId={userId} onLogout={onLogout} />

      <Paper
        sx={{
          padding: '2rem',
          borderRadius: 4,
          boxShadow: 3,
          backgroundColor: '#000000',
          width: '100%', // Ensure full width of parent container
          maxWidth: '1300px', // Increased width to 1300px for better fit
          margin: '2rem auto',
          minHeight: '70vh',
        }}
      >
        <Button
          variant="text"
          color="primary"
          onClick={handleClick}
          sx={{
            marginBottom: '1.5rem',
            color: '#ffffff',
            textTransform: 'none',
            fontWeight: '500',
            '&:hover': { backgroundColor: 'transparent', color: '#90caf9' },
          }}
        >
          <ArrowBack sx={{ marginRight: 1, color: '#ffffff' }} />
          Back to Dashboard
        </Button>

        <Typography
          variant="h4"
          component="h1"
          sx={{
            marginBottom: '1.5rem',
            fontWeight: 700,
            color: '#ffffff',
            fontSize: { xs: '1.8rem', sm: '2.4rem' },
          }}
        >
          Accepted Users
        </Typography>

        <Divider sx={{ marginBottom: '1.5rem', backgroundColor: '#333333' }} />

        <Grid container spacing={2} sx={{ marginTop: '1rem' }}>
          {bookedUsers.map((user, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper
  sx={{
    display: 'flex',
    flexDirection: 'column',  // Changed to column for vertical alignment
    alignItems: 'flex-start',  // Aligning items to the start of the column
    padding: '1rem 2rem',  // Added horizontal padding for better spacing
    borderRadius: '12px',
    backgroundColor: '#2c2c2c',
    boxShadow: 2,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#444444',
      boxShadow: 6,
      transform: 'scale(1.02)',
    },
    width: '100%',  // Ensures the Paper takes full width
    maxWidth: '1200px',  // Increased max width to allow more space
    margin: '0 auto',  // Centers the Paper horizontally
  }}
>
  {/* Avatar and User Name */}
  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
    <Avatar sx={{ width: 60, height: 60, marginRight: 1 }}>
      <PersonOutline sx={{ color: '#ffffff' }} />
    </Avatar>

    <Typography
      variant="body1"
      sx={{
        color: '#e0e0e0',
        fontSize: { xs: '1rem', sm: '1.2rem' },
        fontWeight: '500',
        letterSpacing: '0.5px',
        overflowWrap: 'break-word',
      }}
    >
      {user}
    </Typography>
  </Box>

  {/* Platform and Meeting Link Inputs */}
  <Box sx={{ width: '100%', marginBottom: '1rem' }}>
    <FormControl fullWidth sx={{ marginBottom: 2 }}>
      <InputLabel>Select Platform</InputLabel>
      <Select
        value={selectedPlatform}
        label="Select Platform"
        onChange={(e) => setSelectedPlatform(e.target.value)}
      >
        <MenuItem value="Google Meet">Google Meet</MenuItem>
        <MenuItem value="Zoom">Zoom</MenuItem>
        <MenuItem value="Microsoft Teams">Microsoft Teams</MenuItem>
      </Select>
    </FormControl>

    <TextField
      label="Meeting Link"
      variant="outlined"
      fullWidth
      value={meetingLink}
      onChange={(e) => setMeetingLink(e.target.value)}
      sx={{ marginBottom: 2 }}
    />
  </Box>

  {/* Accept and Reject Buttons */}
  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'flex-start' }}>
    <Button
      variant="contained"
      color="success"
      onClick={() => handleAccept(user)}
      sx={{
        marginBottom: '1rem',
        padding: '0.5rem',
        width: '100%',  // Ensures button takes full width on small screens
      }}
      disabled={loading}
    >
      Accept & Pay
    </Button>
    <Button
      variant="outlined"
      color="error"
      onClick={() => handleReject(user)}
      sx={{
        padding: '0.5rem',
        width: '100%',  // Ensures button takes full width on small screens
      }}
      disabled={loading}
    >
      Reject
    </Button>
  </Box>
</Paper>

            </Grid>
          ))}
        </Grid>
      </Paper>

      <Footer2 />
    </Paper>
  );
}

export default ShowAcceptedUsers;
